<script setup>
import { computed } from 'vue';

/**
 * Anchored table of contents (ТЗ §3.4 — for longer pages). Only renders when
 * there are enough H2 sections to be useful; below the threshold it stays
 * hidden so short pages don't get a pointless one-item outline.
 */
const props = defineProps({
    items: { type: Array, default: () => [] }, // [{ id, text }]
    minItems: { type: Number, default: 3 },
});

const visible = computed(() => props.items.length >= props.minItems);
</script>

<template>
    <nav v-if="visible" aria-label="Table of contents"
         class="mt-4 rounded-lg bg-slate-50 dark:bg-slate-800/60 px-4 py-3">
        <p class="font-medium text-sm mb-2 text-slate-600 dark:text-slate-300">
            {{ $t('Contents') }}
        </p>
        <ul class="list-none flex flex-col gap-1">
            <li v-for="item in items" :key="item.id">
                <a :href="`#${item.id}`"
                   class="text-sm text-blue-600 dark:text-blue-400 hover:underline">
                    {{ item.text }}
                </a>
            </li>
        </ul>
    </nav>
</template>
